module.exports = __webpack_public_path__ + "static/media/user-check.743a04fa.svg";